import React, { useState } from 'react';
import axios from 'axios';

const ModalCreateLink = ({ isVisible, onClose }) => {

    const [values, setValues] = useState({
        type: '',
        plateforme: '',
        lien: '',
    })

    const handleClose = (e) => { if (e.target.id === "wrapper") onClose(); }
    const handleSubmit = (e) => {
        e.preventDefault();

        axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/add_link_download`, values)
            .then(res => {
                window.location.reload(false);
            }).catch(err => console.log(err))
        // }
    }

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4" id="wrapper" onClick={handleClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto">
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Nouveau lien</h2>
                    <button type="button" className="text-slate-400 hover:text-slate-600 text-xl leading-none" onClick={() => onClose()}>&times;</button>
                </div>
                <form className="px-6 py-5" onSubmit={handleSubmit}>

                    <div className="mb-4">
                        <label htmlFor="type" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Type</label>
                        <input type="text" name="type" id="type" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" required onChange={e => setValues({ ...values, type: e.target.value })} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="plateforme" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Plateforme</label>
                        <input type="text" name="plateforme" id="plateforme" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" onChange={e => setValues({ ...values, plateforme: e.target.value })} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="lien" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Lien</label>
                        <input type="text" name="lien" id="lien" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" onChange={e => setValues({ ...values, lien: e.target.value })} />
                    </div>

                    <button type="submit" className="w-full rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600 sm:w-auto">Enregistrer</button>
                    <div className="py-4 text-center">
                        <p id="error" className='text-red-600'></p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCreateLink;